/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

var re =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export default {
  Ban: (ban) =>
    !isNaN(ban.trim()) && ban.trim().length < 21 ? ban.trim() : false,
  Email: (email) =>
    re.test(String(email).trim().toLowerCase()) ? email.trim() : false,
};
